import { FormattedMessage } from 'react-intl';
import TabularPage from '../components/tabs/TabularPage';
import { ECONOMIC_RESERVE_ROUTES } from 'constants/routes';

const routes = [
    {
        name: <FormattedMessage id="economic_reserve_data" />,
        relativePath: ECONOMIC_RESERVE_ROUTES.PSECONRESERVE,
    },
    {
        name: <FormattedMessage id="economic_reserve_variables" />,
        relativePath: ECONOMIC_RESERVE_ROUTES.PSECONRES,
    },
];

const EconomicReserve = () => {
    return <TabularPage isAutoForm routes={routes} />;
};

export default EconomicReserve;
